module.exports = __webpack_public_path__ + "a19a4ef10a409e2d4924b69d04c69864.woff";


//////////////////
// WEBPACK FOOTER
// ./ClientApp/fonts/Avenir-Roman.woff
// module id = 643
// module chunks = 0